<template>
    <div class="order_detail">
        <nav-bar />
        <search-bar />
        <div class="main" v-if="loading">
            <div class="nav">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/me/myservice' }">服务订单</el-breadcrumb-item>
                    <el-breadcrumb-item>订单详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="info_box">
                <!-- 订单信息 -->
                <div class="order_cell fr afs mb20">
                    <p class="fz16 order_cell_title">订单信息:</p>
                    <div class="pay_table">
                        <div class="tr fr">
                            <div class="th fg fs">服务类型</div>
                            <div class="th fg fs">服务工程师</div>
                            <div class="th fg fs">服务距离</div>
                            <div class="th fg fs">价格</div>
                        </div>
                        <div class="tr fr">
                            <div class="td fg fs">
                                <span>{{order_detail.type_name}}</span>
                            </div>
                            <div class="td fg fs">
                                <span>{{order_detail.level_name}}</span>
                            </div>
                            <div class="td fg fs fr ac jc">
                                <span>{{order_detail.order_distance}}km</span>
                            </div>
                            <div class="td fg fs">
                                <span>￥{{order_detail.order_actual_price}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order_cell fr afs mb20">
                    <p class="fz16 order_cell_title">问题描述:</p>
                    <div class="ml20">
                        <el-input
                            type="textarea"
                            resize="none"
                            :value="order_detail.order_remark"
                            disabled
                        ></el-input>
                    </div>
                </div>
                <div class="order_cell fr afs mb20" v-if="order_detail.order_imgs.length">
                    <p class="fz16 order_cell_title">图片描述:</p>
                    <div class="ml20">
                        <el-image
                            :src="i"
                            v-for="(i,k) in order_detail.order_imgs.split(',')"
                            :key="k"
                            class="img"
                            :preview-src-list="order_detail.order_imgs.split(',')"
                        />
                    </div>
                </div>
            </div>
        </div>
        <footer-bar />
    </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
export default {
    props: {},
    data() {
        return {
            order_detail: {},
            loading: false
        };
    },
    computed: {},
    created() {
        this.getServiceOrderDetail();
    },
    mounted() {},
    watch: {},
    methods: {
        // 订单详情
        getServiceOrderDetail() {
            this.post("serviceInterfaces/v1.0/getServiceOrderDetail", {
                order_id: this.$route.query.id
            }).then(res => {
                this.order_detail = res.data;
                this.loading = true;
            });
        }
    },
    components: { NavBar, SearchBar, FooterBar }
};
</script>

<style scoped lang="scss">
.order_detail {
    .main {
        width: 1200px;
        margin: 0 auto;
        padding: 20px 0;
        .nav {
            background-color: #fff;
            padding: 20px;
            margin-bottom: 20px;
        }
        .info_box {
            background-color: #fff;
            padding: 20px;
            font-size: 14px;
            .order_cell {
                .order_cell_title {
                    width: 130px;
                    text-align: right;
                }
                .pay_table {
                    width: calc(100% - 170px);
                    margin-left: 20px;
                    border: 1px solid #e5e5e5;
                    .tr {
                        height: 50px;
                        border-bottom: 1px solid #e5e5e5;
                        &:nth-of-type(2) {
                            border-bottom: none;
                        }
                        .th {
                            height: 50px;
                            background-color: #f0f6ff;
                            font-weight: 800;
                        }
                        .th,
                        .td {
                            width: 25%;
                            font-size: 14px;
                            text-align: center;
                            line-height: 50px;
                            height: 100%;
                            border-right: 1px solid #e5e5e5;
                            // border-bottom: 1px solid #e5e5e5;
                            &:last-child {
                                border-right: none;
                            }
                        }
                    }
                }
                .img {
                    width: 100px;
                    height: 100px;
                    margin-right: 20px;
                }
            }
            .receipt {
                width: 40%;
                border: 1px solid #e5e5e5;
                .top {
                    padding: 20px;
                    border-bottom: 1px solid #e5e5e5;
                }
                .bottom {
                    padding: 30px 20px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/me/technician/servicedetail.vue